var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18381",
    "data-name": "Group 18381",
    transform: "translate(0.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4287",
    "data-name": "Rectangle 4287",
    transform: "translate(-0.436)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18367",
    "data-name": "Group 18367",
    transform: "translate(16.068 4.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29713",
    "data-name": "Path 29713",
    d: "M38.789,48.814a2.743,2.743,0,1,1-5.486,0V37.842a2.743,2.743,0,1,1,5.486,0Zm11.641,14.3a2.743,2.743,0,0,1-5.486,0V52.143a2.743,2.743,0,1,1,5.486,0Zm9.684,0a2.743,2.743,0,1,1-5.486,0V52.143a2.743,2.743,0,1,1,5.486,0ZM71.8,48.814a2.743,2.743,0,1,1-5.486,0V37.842a2.743,2.743,0,1,1,5.486,0Z",
    transform: "translate(-33.303 -21.01)",
    fill: "#96c03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29714",
    "data-name": "Path 29714",
    d: "M75.355,18.057V37.779a2.288,2.288,0,0,1-2.288,2.288H53.425a2.288,2.288,0,0,1-2.288-2.288V18.057ZM63.247,6.683c-6.577,0-11.925,4.381-12.084,9.835H75.331C75.171,11.064,69.823,6.683,63.247,6.683Zm-5.2,6.351A1.34,1.34,0,1,1,59.4,11.678,1.357,1.357,0,0,1,58.044,13.034Zm10.411,0a1.356,1.356,0,1,1,1.357-1.356A1.356,1.356,0,0,1,68.455,13.034Z",
    transform: "translate(-43.978 -4)",
    fill: "#96c03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29715",
    "data-name": "Path 29715",
    d: "M64.8,4.5a.364.364,0,0,1-.607.4L61.326.566a.364.364,0,0,1,.608-.4Zm9,0a.364.364,0,0,0,.607.4L77.288.566a.364.364,0,0,0-.608-.4Z",
    transform: "translate(-50.041 0)",
    fill: "#96c03a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29716",
    "data-name": "Path 29716",
    d: "M7.737,138v-7.034H4.383a2.6,2.6,0,0,0,0,5.191H6.2V138H4.383a4.435,4.435,0,0,1,0-8.87H9.576V138H7.737Zm10.739.007v-4.753a2.522,2.522,0,0,0-5.04,0v4.753H11.621v-4.753a4.336,4.336,0,0,1,8.67,0v4.753Zm3.919-1.853h3.873a2.593,2.593,0,0,0,0-5.182H22.395V129.11h3.873a4.456,4.456,0,0,1,0,8.91H22.395Zm0-5.182h0Zm34.57,5.182h3.872a2.593,2.593,0,0,0,0-5.182H56.965V129.11h3.872a4.456,4.456,0,0,1,0,8.91H56.965Zm-14.992-2.6a4.519,4.519,0,1,1,4.519,4.513A4.516,4.516,0,0,1,41.973,133.558Zm1.853,0a2.667,2.667,0,1,0,2.667-2.667,2.668,2.668,0,0,0-2.667,2.667Zm9.089-4.447h1.865v8.907H52.914Zm-13.99,5.812a3.112,3.112,0,0,0-1.572-5.8H32.8v1.864h4.552a1.25,1.25,0,0,1,0,2.5H32.811v1.865h3.745a3.465,3.465,0,0,1,1.459,1.571,3.008,3.008,0,0,1,.263,1.1h1.864a4.821,4.821,0,0,0-.425-1.855A5,5,0,0,0,38.924,134.923Z",
    transform: "translate(2.068 -72.646)",
    fill: "#404040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.90fa25d4fbeeae8da0b4713d60ed8639.svg";
export { ForwardRef as ReactComponent };